var BFS;

function BrowseFS(ObjTarget, BrowseFor, UNC, AllowCreateFolder, ImageServer, NewFolderCount)
{
	// assigning methods
	this.popup = BFS_popup;

	// validate input parameters
	if (!ObjTarget)
	{
		return BFS_error("Error calling the BrowseFS: no target control specified");
	}
	if (ObjTarget.value == null)
	{
		return BFS_error("Error calling the BrowseFS: parameter specified is not valid target control");
	}
	this.target = ObjTarget;

	if (BrowseFor)
	{
		this.BrowseFor = '&browsefor=' + BrowseFor;
	}
	else
	{
		this.BrowseFor = '&browsefor=folder';
	}

	if (UNC != undefined)
	{
		// Only browse within one ImageServer
		this.CrossServers = '&CrossServers=0';
		this.path = '&path=' + UNC;
		this.target.value = UNC;
	}
	else
	{
		this.CrossServers = '&CrossServers=1';
		this.path = ''; // BrowseFS.php's TOP folder notation
	}

	if (AllowCreateFolder != undefined)
	{
		this.AllowCreateFolder = '&AllowCreateFolder=' + AllowCreateFolder;
	}
	else
	{
		this.AllowCreateFolder = '&AllowCreateFolder=0';
	}

	if (ImageServer != undefined)
	{
		this.ImageServer = '&ImageServer=' + ImageServer;
	}
	else
	{
		this.ImageServer = '';
	}

	if (NewFolderCount != undefined)
	{
		this.NewFolderCount = '&NewFolderCount=' + NewFolderCount;
	}
	else
	{
		this.NewFolderCount = '&NewFolderCount=0';
	}

	// register ths instance
	BFS = this;
}

function BFS_popup()
{
	var obj_BFSwindow = window.open('/BrowseFS.php?id=' + this.id + this.BrowseFor + this.path + this.CrossServers + this.AllowCreateFolder + this.NewFolderCount + this.ImageServer, 'Browse', 'width=440,height=400,status=no,top=200,left=500,dependent=yes,alwaysRaised=yes, scrollbars,resizable');
	obj_BFSwindow.opener = window;
	obj_BFSwindow.focus();
}

function BFS_error(str_message)
{
	alert(str_message);
	return null;
}
